import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
import Image from "gatsby-image"
import { Link } from "gatsby"
import InView from "react-intersection-observer"
import { motion } from "framer-motion"

class LogoStrip extends Component {
  render() {
    const content = this.props.content
    const sectionClasses = helpers.sectionClasses(content.sectionOptions)
    return (
      <section className={`${sectionClasses}`}>
        <div className="container">
          {content.title ? (
            <div className="flex justify-center pb-6">
              <div className="lrg:px-6 tab:w-9/12 text-center">
                <p>{content.title}</p>
              </div>
            </div>
          ) : (
            ""
          )}

          <InView threshold={0.25} triggerOnce={true}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                transition={{ duration: 0.8 }}
                className="flex justify-center items-center flex-wrap"
              >
                {content.logos.map((logo, index) => {
                  return (
                    <React.Fragment key={index}>
                      {logo.caption ? (
                        <a
                          href={logo.caption.replace(/(<([^>]+)>)/gi, "")}
                          className="w-1/2 med:w-auto logo"
                          target="_blank"
                          rel="noreferrer"
                          //key={index}
                        >
                          <Image
                            
                            fluid={logo.localFile.childImageSharp.fluid}
                            alt={logo.localFile.childImageSharp.alt}
                            style={{
                              margin: "1rem 2rem",
                              width: "200px",
                              height: "85px",
                            }}
                            imgStyle={{ objectFit: "contain" }}
                          />
                        </a>
                      ) : (
                        <Image
                         // key={index}
                          fluid={logo.localFile.childImageSharp.fluid}
                          alt={logo.localFile.childImageSharp.alt}
                          style={{
                            margin: "1rem 2rem",
                            width: "200px",
                            height: "85px",
                          }}
                          imgStyle={{ objectFit: "contain" }}
                        />
                      )}
                    </React.Fragment>
                  )
                })}
              </motion.div>
            )}
          </InView>
        </div>
      </section>
    )
  }
}

export default LogoStrip
